import { gql } from '@apollo/client'

export const PLACE_ORDER = gql`
  mutation PlaceOrder($cartId: String!, $applePayToken: String) {
    cartId @client @export(as: "cartId")

    placeOrder(input: { cart_id: $cartId, apple_pay_token: $applePayToken }) {
      order {
        order_id
        order_number
        payment_url
      }
    }
  }
`
